import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Card, Image, Checkbox, Button } from 'semantic-ui-react';
import i18next from 'i18next';

const SmartPromotion = (props) => {
    const { handleUpdateSmartPromotion, upsell } = props;
    const { imgUrl, title, description, Settings, menuId } = upsell;
    const [checked, setChecked] = useState(!upsell.isDisabled);
    const [settingsVisible, setSettingsVisible] = useState(false);
    const [settings, setSettings] = useState(upsell.options);
    const isRtl = i18next.dir() === 'rtl';

    return (
        <Card className="option-card">
            <Image src={imgUrl} wrapped ui={false} />
            <Card.Content style={{ height: 93 }}>
                <Button
                    icon={settingsVisible ? 'check' : 'cog'}
                    color={settingsVisible ? 'blue' : null}
                    circular
                    size="big"
                    style={{ position: 'absolute', left: isRtl ? '20px' : undefined, right: !isRtl ? '20px' : undefined }}
                    onClick={() => {
                        setSettingsVisible(!settingsVisible);

                        if (settingsVisible) {
                            handleUpdateSmartPromotion({ ...upsell, options: settings });
                        }
                    }}
                />
                <Card.Header style={{ textAlign: isRtl ? 'right' : 'left' }}>{i18next.t(title)}</Card.Header>
                <Card.Description style={{ width: 200 }}>
                    {i18next.t(description)}
                </Card.Description>
            </Card.Content>
            {!settingsVisible && <Card.Content extra style={{ display: 'flex' }}>
                {i18next.t(checked ? 'disable' : 'enable')} <Checkbox
                    checked={checked}
                    toggle
                    style={{ margin: '0 10px' }}
                    onChange={(e, data) => {
                        setChecked(data.checked);
                        handleUpdateSmartPromotion({ ...upsell, isDisabled: !data.checked });
                    }}
                />
            </Card.Content>}
            {settingsVisible && <Settings settings={settings} handleSettingsUpdate={setSettings} menuId={menuId} />}
        </Card>
    );
};

SmartPromotion.propTypes = {
    
    handleUpdateSmartPromotion: PropTypes.func,
    upsell: PropTypes.object,
    isDisabled: PropTypes.bool,
    options: PropTypes.object,
    imgUrl: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string,
    Settings: PropTypes.func
};

export default SmartPromotion;